/**
 * Tokens som trengs i JavaScript.
 *
 * Resten av designspråket ligger i `src/styles/tokens.css` og leses derfra —
 * fargene skal defineres ett sted, ikke to. Se docs/13-design.md.
 */

/**
 * Hurtigknapper har en fast palett, ikke fri fargevelger. Da er kontrasten
 * mot svart garantert, alle farger er prøvd i dårlig lys, og oppsettet går
 * raskere. En fri velger gir uvegerlig en knapp i mørkeblått som ikke synes.
 */
export const MARKER_COLORS = {
  gra: "#6E6A63",
  gul: "#C0A33E",
  bla: "#4E7FA8",
  rust: "#8E5C4A",
  lilla: "#8A5FA0",
  gronn: "#5E8F5A",
} as const;

export type MarkerColor = (typeof MARKER_COLORS)[keyof typeof MARKER_COLORS];

/** Rekkefølgen nye knapper får farge i. */
export const MARKER_PALETTE: readonly MarkerColor[] = [
  MARKER_COLORS.gul,
  MARKER_COLORS.bla,
  MARKER_COLORS.lilla,
  MARKER_COLORS.rust,
  MARKER_COLORS.gronn,
  MARKER_COLORS.gra,
];

/**
 * Terskelen for at tidskoden er «gammel».
 *
 * TJUEFIRE TIMER, satt av brukeren 01.11.2026: «Hvis tidskoden ikke er
 * jammet av en tekniker de siste 24 timene, så skal tidskoden være rød.»
 * Sto på tolv, som var et anslag i påvente av drifttesten.
 *
 * Det er en opptaksdag. En jam fra i går gjelder ikke i dag — boksene er
 * slått av og på, og avviket er ukjent — men den gjelder resten av dagen
 * den ble satt.
 *
 * Ligger i konfigurasjon, ikke som en konstant spredt i koden.
 * Se docs/10-slagplan.md.
 */
export const TC_STALE_AFTER_HOURS = 24;
